import EllipsisHorizontalIcon from '../internal/svg-icons/EllipsisHorizontal'
import { ButtonBase, ButtonBaseProps } from '../ButtonBase'
import styles from './breadcrumbCollapsed.module.scss'
import { SvgIconProps } from '../SvgIcon'
import clsx from 'clsx'

export interface BreadcrumbCollapsedProps extends ButtonBaseProps {
  slots?: {
    CollapsedIcon: SvgIconProps['Component']
  }
  slotProps?: {
    collapsedIcon: SvgIconProps
  }
}

export function BreadcrumbCollapsed(props: BreadcrumbCollapsedProps) {
  const { slots, slotProps, ...otherProps } = props

  return (
    <li>
      <ButtonBase
        focusRipple
        {...otherProps}
        classes={{
          ...otherProps?.classes,
          root: clsx(styles.root, otherProps?.classes?.root),
        }}
      >
        <EllipsisHorizontalIcon
          Component={slots?.CollapsedIcon}
          {...slotProps?.collapsedIcon}
        />
      </ButtonBase>
    </li>
  )
}
